/**
 * @generated SignedSource<<79f5b4823868a2052709ca0cf64b10a4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OverviewInstagram_tradeFirm$data = {
  readonly instagram: {
    readonly feed: ReadonlyArray<{
      readonly imageUrl: string | null;
      readonly link: string | null;
    } | null> | null;
    readonly username?: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "OverviewInstagram_tradeFirm";
};
export type OverviewInstagram_tradeFirm$key = {
  readonly " $data"?: OverviewInstagram_tradeFirm$data;
  readonly " $fragmentSpreads": FragmentRefs<"OverviewInstagram_tradeFirm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isEditMode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "OverviewInstagram_tradeFirm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InstagramFeedType",
      "kind": "LinkedField",
      "name": "instagram",
      "plural": false,
      "selections": [
        {
          "condition": "isEditMode",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "username",
              "storageKey": null
            }
          ]
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InstagramFeedItemType",
          "kind": "LinkedField",
          "name": "feed",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "link",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};

(node as any).hash = "89d3ef04b6cacadaef9193b65a1a2cfd";

export default node;
